import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NotificationService } from 'src/app/Services/notification.service';
import { TransactionService } from 'src/app/Services/transaction.service';
import { Utility } from 'src/app/Utilities/utility';

@Component({
  selector: 'app-spra-validation',
  templateUrl: './spra-validation.component.html',
  styleUrls: ['./spra-validation.component.css']
})
export class SpraValidationComponent implements OnInit {
  private utility: Utility;
  SPRAId:number=0;
  constructor(
    private _TransactionService: TransactionService
    ,private route: ActivatedRoute
    ,private router: Router
    , private cookieService: CookieService
    , private _NotificationService:NotificationService
    ) { 
      this.utility = new Utility(this.cookieService);
    }

  
  ngOnInit(): void {

if(!this.utility.CheckNumberRequired(this.utility.user.employeeId)){
  // this._NotificationService.showWarning("You are not logged in.","Warnnig");
  this.utility.RedirectToLogin();
}else{
  this.route.params.subscribe((params) =>{
    if(params){
      this.SPRAId=parseInt(atob(params.Id))
      if(this.SPRAId!=undefined && this.SPRAId!=0){
        this._TransactionService.GetSpraDetailForValidation(this.SPRAId,this.utility.user.employeeId).toPromise().then((d:any)=>{
          if(d){
            
            let data:any = JSON.parse(d);  
            if(data.RedirectionURL!=undefined){ //Condition added by rahul yadav on 9/7/2021 in case of null url 
              this.router.navigate([data.RedirectionURL], {
                state:data
              });
            }else{
              this._NotificationService.showWarning("You can not validate this SPRA.","Warnnig");   
          }
          }
          else{
            this._NotificationService.showWarning("You can not validate this SPRA.","Warnnig");   
        }
        }, (error) => {                              //Error callback
          this.utility.Error(error);
        });
      }
    }
   
  });
}

  

  }





}
